import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { updateProfileModal } from "../../../redux/actions/taskAction";
import firebase from "../../../util/firebaseConfig";
import "firebase/auth";
import alertify from "alertifyjs";
import {
  Button,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Image,
  Menu,
  Input,
  Modal,
  Label,
} from "semantic-ui-react";
function ProfileModal() {
  const user = useSelector((state) => state.firebase.auth);
  // const dispatch = useDispatch();
  const [authorized, setAuthorized] = useState(false);
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    officeNo: "",
    personalNo: "",
    authority: "",
    strAdd: "",
    strAdd2: "",
    city: "",
    stateProvince: "",
    postalZip: "",
    country: "",
    createdAt: "",
    paymentPlan: "",
    accStatus: "",
  });

  const db = firebase.firestore();
  const docRef = db
    .collection("customers")
    .doc(user.uid)
    .collection("subscriptions");
  useEffect(() => {
    db.collection("profile")
      .doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          if (doc.data().authority === "Collaborator") {
            setState({
              authority: "Collaborator",
              officeNo: doc.data().officeNo || "",
              personalNo: doc.data().personalNo || "",
              strAdd: doc.data().strAdd || "",
              strAdd2: doc.data().strAdd2 || "",
              city: doc.data().city || "",
              stateProvince: doc.data().stateProvince || "",
              postalZip: doc.data().postalZip || "",
              country: doc.data().country || "",
            });
            setAuthorized(true);
          } else {
            docRef.onSnapshot((snap) => {
              snap.forEach((item) => {
                setState({
                  subscriptionID: item.id,
                  authority: "Owner",
                  officeNo: doc.data().officeNo || "",
                  personalNo: doc.data().personalNo || "",
                  strAdd: doc.data().strAdd || "",
                  strAdd2: doc.data().strAdd2 || "",
                  city: doc.data().city || "",
                  stateProvince: doc.data().stateProvince || "",
                  postalZip: doc.data().postalZip || "",
                  country: doc.data().country || "",
                  createdAt: item.data().created.toDate().toDateString(),
                  paymentPlan: item.data().items[0].price.product.name,
                  accStatus: item.data().status,
                });
              });
            });
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cancelSubscription = () => {
    alertify.confirm(
      "Cancel Subscription",
      "Are you sure you want to cancel the subscription?",
      function () {
        db.collection("customers")
          .doc(user.uid)
          .delete()
          .then(() => {
            db.collection("customers")
              .doc(user.uid)
              .collection("checkout_sessions")
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  if (doc.exists)
                    doc.ref.delete().then(() => {
                      db.collection("customers")
                        .doc(user.uid)
                        .collection("subscriptions")
                        .get()
                        .then((snap) => {
                          snap.forEach((doc) => {
                            if (doc.exists)
                              doc.ref.delete().then(() => {
                                alertify.alert(
                                  "Cancel Subscription",
                                  "The subscription was deleted successfully.",
                                  function () {
                                    window.location.reload();
                                  }
                                );
                              });
                          });
                        });
                    });
                });
              });
          });
      },
      function () {
        alertify.error("Cancel");
      }
    );
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    db.collection("profile")
      .doc(user.uid)
      .set(
        {
          ...state,
          // createdAt: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        alertify.success("Update Successful");
      })
      .catch((err) => {
        alertify.error(err);
      });
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Menu.Item style={{ color: "white", height: "100%" }}>
          {authorized ? "Profile" : "Account"}
        </Menu.Item>
      }
    >
      <Modal.Header>
        {authorized ? "Profile Information" : "Account Information"}
      </Modal.Header>
      <Modal.Content image>
        <Image
          size="small"
          src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
          // src={user.photoURL}
          wrapped
        />
        <Modal.Description as={Container} style={{ width: "100%" }}>
          <Form>
            <Form.Field>
              <Header>
                {user.displayName} {authorized ? "(Collaborator)" : "(Owner)"}
              </Header>
            </Form.Field>

            {!authorized && (
              <Form.Field>
                <Header>
                  Payment Information
                  <Label color="green">{state.accStatus}</Label>
                </Header>
                <Grid>
                  <Grid.Column floated="left" width={11}>
                    <Form.Field as="h4">
                      Selected payment plan: {state.paymentPlan}
                    </Form.Field>
                    <Form.Field as="h4" style={{ marginTop: "-5px" }}>
                      Created at: {state.createdAt}
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column floated="right" width={5}>
                    <Button
                      disabled={state.accStatus === "canceled"}
                      onClick={cancelSubscription}
                      color="red"
                    >
                      Cancel Subscription
                    </Button>
                  </Grid.Column>
                </Grid>
              </Form.Field>
            )}
            <Divider />
            <Header>User Information</Header>
            <Form.Group widths="equal">
              <Form.Field>
                <label>E-mail</label>
                <Form.Field fluid>
                  <Header as="h4" style={{ marginTop: "10px" }}>
                    {user.email}
                  </Header>
                </Form.Field>
              </Form.Field>
              <Form.Field>
                <label>Office Number</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      officeNo: e && e.target && e.target.value,
                    })
                  }
                  value={state.officeNo}
                  fluid
                  placeholder="Office Number"
                />
              </Form.Field>
              <Form.Field>
                <label>Personal Number (Optional)</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      personalNo: e && e.target && e.target.value,
                    })
                  }
                  value={state.personalNo}
                  fluid
                  placeholder="Personal Number"
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field width="5">
                <label>Street Address</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      strAdd: e && e.target && e.target.value,
                    })
                  }
                  value={state.strAdd}
                  fluid
                  placeholder="Street Address"
                />
              </Form.Field>
              <Form.Field width="5">
                <label>City</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      city: e && e.target && e.target.value,
                    })
                  }
                  value={state.city}
                  fluid
                  placeholder="City"
                />
              </Form.Field>
              <Form.Field width="5">
                <label>State/Province</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      stateProvince: e && e.target && e.target.value,
                    })
                  }
                  value={state.stateProvince}
                  fluid
                  placeholder="State/Province"
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <label>Street Address 2</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      strAdd2: e && e.target && e.target.value,
                    })
                  }
                  value={state.strAdd2}
                  fluid
                  placeholder="Street Address 2"
                />
              </Form.Field>
              <Form.Field>
                <label>Postal/Zip</label>
                <Input
                  onChange={(e) =>
                    setState({
                      ...state,
                      postalZip: e && e.target && e.target.value,
                    })
                  }
                  value={state.postalZip}
                  fluid
                  placeholder="Postal/Zip"
                />
              </Form.Field>
              <Form.Field>
                <label>Country</label>
                <Input
                  name="country"
                  onChange={(e) =>
                    setState({
                      ...state,
                      country: e && e.target && e.target.value,
                    })
                  }
                  value={state.country}
                  fluid
                  placeholder="Country"
                />
              </Form.Field>
            </Form.Group>
            <Divider />
            <Grid divided="vertically">
              <Grid.Row columns="3">
                <Grid.Column />
                <Grid.Column>
                  <Form.Button
                    fluid
                    centered
                    color="twitter"
                    onClick={handleUpdate}
                  >
                    Update
                  </Form.Button>
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={() => setOpen(false)}>
          Back
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ProfileModal;
